import React from 'react';
import {Card, CardContent, CardHeader, Grid, TextField, Typography, Box, Divider} from '@mui/material';
import {IHesap} from 'src/constants/types/logbook';
import {AccountBalanceWallet, Payments, Assessment} from '@mui/icons-material';

interface SatislarCardProps {
    formik: any;
    isletmeHesaplari: IHesap[];
    kasaHesap: { id: number; hesapAdi: string };
    toplamSatis: number;
    nakitSatis: number;
}

const SatislarCard: React.FC<SatislarCardProps> = ({
                                                       formik,
                                                       isletmeHesaplari,
                                                       kasaHesap,
                                                       toplamSatis,
                                                       nakitSatis,
                                                   }) => {
    return (
        <Card sx={{
            height: '100%',
            background: 'linear-gradient(135deg, #fff 0%, #f9f9f9 100%)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            border: '1px solid rgba(0,0,0,0.05)'
        }}>
            <CardHeader 
                title={
                    <Box display="flex" alignItems="center" gap={1}>
                        <Assessment color="primary" />
                        <Typography variant="h6" fontWeight={800} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
                            Satış Özeti
                        </Typography>
                    </Box>
                }
            />
            <Divider sx={{ opacity: 0.6 }} />
            <CardContent sx={{ p: 1.5 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'primary.light', borderRadius: '12px', color: 'primary.dark' }}>
                            <Typography variant="overline" sx={{ fontWeight: 800 }}>Toplam Satış</Typography>
                            <Typography variant="h4" fontWeight={900}>{toplamSatis.toFixed(2)} ₺</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ p: 1.5, bgcolor: 'secondary.light', borderRadius: '12px', color: 'secondary.dark' }}>
                            <Typography variant="overline" sx={{ fontWeight: 800 }}>Tahmini Nakit</Typography>
                            <Typography variant="h4" fontWeight={900}>{nakitSatis.toFixed(2)} ₺</Typography>
                        </Box>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ mb: 0.5, mt: 0.5, fontWeight: 700, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Payments fontSize="small" /> Kasa ve Hesap Detayları
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            size="small"
                            type={'number'}
                            label={'Eldeki Nakit (Kasa)'}
                            name="kasa"
                            InputProps={{
                                startAdornment: <AccountBalanceWallet sx={{ mr: 1, color: 'action.active', opacity: 0.5 }} />,
                            }}
                            value={formik.values.kasa}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.kasa && Boolean(formik.errors.kasa)}
                            helperText={formik.touched.kasa && formik.errors.kasa}
                        />
                    </Grid>
                    {isletmeHesaplari.map((hesap: IHesap, index: number) => {
                        if (hesap.hesapAdi === 'Kasa') return null;
                        const satisIndex = formik.values.satislar.findIndex(
                            (s: any) => s.hesap === hesap.id
                        );
                        if (satisIndex === -1) return null;
                        const miktar = formik.values.satislar[satisIndex].miktar;
                        return (
                            <Grid item xs={12} md={6} key={hesap.id || index}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type={'number'}
                                    label={hesap.hesapAdi}
                                    name={`satislar[${satisIndex}].miktar`}
                                    value={miktar}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                        formik.touched.satislar?.[satisIndex] &&
                                        Boolean((formik.errors.satislar?.[satisIndex] as any)?.miktar)
                                    }
                                    helperText={
                                        formik.touched.satislar?.[satisIndex] &&
                                        (formik.errors.satislar?.[satisIndex] as any)?.miktar
                                    }
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SatislarCard;
